import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";

import CampoFormulario from "../../components/CampoFormulario";
import { CAMPO_MATERIA } from "../../model/campos";

/**
 * Paso Clase: la materia, que viene de SICUC. Elegirla carga los estudiantes
 * del grupo, que se ven en el paso Estudiantes.
 */
const PasoClase = ({ valores, errores, onChange, catalogos, ayuda }) => (
  <Grid container spacing={3}>
    <Grid item xs={12}>
      <CampoFormulario
        campo={CAMPO_MATERIA}
        valor={valores[CAMPO_MATERIA.name]}
        error={errores[CAMPO_MATERIA.name]}
        onChange={onChange}
        opciones={catalogos[CAMPO_MATERIA.catalogo]}
        ayuda={ayuda}
      />
    </Grid>
  </Grid>
);

PasoClase.propTypes = {
  valores: PropTypes.object.isRequired,
  errores: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  catalogos: PropTypes.object.isRequired,
  ayuda: PropTypes.string,
};

PasoClase.defaultProps = { ayuda: "" };

export default PasoClase;
